<template>
  <nav class="navbar navbar-expand-lg navbar-light">
    <div class="container-fluid">
      <a class="navbar-brand" href="#">{{ routeName }}</a>
      <button
        class="navbar-toggler navbar-burger"
        type="button"
        @click="toggleSidebar"
        :aria-expanded="$sidebar.showSidebar"
        aria-label="Toggle navigation"
      >
        <span class="navbar-toggler-bar"></span>
        <span class="navbar-toggler-bar"></span>
        <span class="navbar-toggler-bar"></span>
      </button>
      <div class="collapse navbar-collapse">
      </div>

      <drop-down
          class="nav-item"
          :title="fullname"
          title-classes="nav-link"
          icon="ti-user"
          id="user-dropdown"
        >
          <a class="dropdown-item" @click="logout">Logout</a>
        </drop-down>
    </div>
  </nav>
</template>
<script>
import axios from 'axios'
import api  from "@/static/config.json";

export default {
  computed: {
    routeName() {
      const { name } = this.$route;
      return this.capitalizeFirstLetter(name);
    },
  },
  data() {
    return {
      activeNotifications: false,
      fullname: '',
    };
  },
  methods: {
    capitalizeFirstLetter(string) {
      return string.charAt(0).toUpperCase() + string.slice(1);
    },
    toggleNotificationDropDown() {
      this.activeNotifications = !this.activeNotifications;
    },
    closeDropDown() {
      this.activeNotifications = false;
    },
    toggleSidebar() {
      this.$sidebar.displaySidebar(!this.$sidebar.showSidebar);
    },
    hideSidebar() {
      this.$sidebar.displaySidebar(false);
    },
    logout(){
            const token = localStorage.getItem('token');
            axios.post(api.API_URL+'/logout', {
                },
                
                {
                 headers: { Authorization: `Bearer ${token}`}
                }
                )
                    .then((data) => {
                        localStorage.removeItem("token");
                        this.$router.push({name: 'login'})
                    })
                    .catch((response) => {
                          if(response.data.error.code =='token_could_not_verified'){
                            this.$router.push({name: 'login'})
                          }
                    });
    }
  },
  created(){
    this.fullname = localStorage.getItem('fullname');
      
  }
};

// function Refresh() {
//   const token = localStorage.getItem('token');
//             axios.post(api.API_URL+'/refresh', {
//                 },
                
//                 {
//                  headers: { Authorization: `Bearer ${token}`}
//                 }
//                 )
//                     .then((data) => {
//                     })
//                     .catch((response) => {
//                       if(response.data.error.code =='token_could_not_verified'){
//                               localStorage.removeItem("token");
//                               this.$router.push('/login')
//                           }
//                     });
// }
// setInterval( Refresh, 2*60*1000 );

</script>
<style></style>
